import { createContext } from "react";
import { type FormAction } from "src/components/Form/Form.types.ts";
import type { FormConfig } from "src/system/module.types.ts";
import type { FieldValues } from "react-hook-form";
import type {
  ValidFormData,
  ValidSaveFormResponseData,
} from "src/components/Form/hooks/useResourceForm/useResourceForm.ts";
import type { FormStore } from "src/components/Form/FormStore.ts";

export type ResourceFormContextValue<
  FormValues extends FieldValues = FieldValues,
  FormData extends ValidFormData = ValidFormData,
> = {
  resource: string;
  lang: string;
  action: FormAction;
  meta?: any;
  requestParams?: Record<string, any>;
  tab?: string;
  id: string | undefined;
  formConfig: FormConfig<FormValues, any, FormData, any>;
  onSaveSuccess?: (response: ValidSaveFormResponseData) => void;
  formStore: FormStore;
};

export const ResourceFormContext = createContext<ResourceFormContextValue<
  any,
  any
> | null>(null);
